function quadInOut(t) {
    t /= 0.5
    if (t < 1) return 0.5*t*t
    t--
    return -0.5 * (t*(t-2) - 1)
}

module.exports = quadInOut


//////////////////
// WEBPACK FOOTER
// ../node_modules/eases/quad-in-out.js
// module id = 106
// module chunks = 0